export default __webpack_public_path__ + "static/media/inbound-by-road.fd5c1967.svg";